import React from "react";
import AuthProvider, {
  AuthIsNotSignedIn,
  AuthIsSignedIn,
} from "../context/authContext";
import SignInRoute from "./SignInRoute";
import MainRoute from "./MainRoute";
import SsoHandler from "../components/ssoHandler";

export const AppRoute = () => (
  <AuthProvider>
    <SsoHandler>
      <AuthIsSignedIn>
        <MainRoute />
      </AuthIsSignedIn>
      <AuthIsNotSignedIn>
        <SignInRoute />
      </AuthIsNotSignedIn>
    </SsoHandler>
  </AuthProvider>
);
